/** Ключи разделов левого меню (должны совпадать с route.label в siteMaps) */
export const MENU_SECTION_LABELS = ['Главная', 'Сервисы', 'Справочники', 'Служебные'] as const;

/** project_data — иконка, описание, API, чат, тема, меню, футер, брендбук, сервисы */
export interface ProjectData {
  icon?: string;
  description?: string;
  /** Ссылка на брендбук (страница, например https://taler.uno/wiki/brand-book.html, или PDF) */
  brand_book?: string;
  api_access?: Record<string, string>;
  chat_access?: Record<string, string>;
  theme?: string;
  /** Включённые разделы левого меню (по label). Пусто = все разделы */
  enabled_menu?: string[];
  /** Включённые подразделы по разделам: раздел -> имена пунктов. Пусто/нет = все пункты раздела */
  enabled_submenu?: Record<string, string[]>;
  /** Ссылка в футере (например https://teslapay.eu) */
  footer_link?: string;
  /** JSON сервисов (возвращается из БД, текстовое поле) */
  services?: string;
  /** Email отправителя для UniOne (from_email). Для SMS используется имя проекта. */
  from_email?: string;
  /** Базовый URL для ассетов email-шаблонов (PNG/SVG иконок) */
  assets_base_url?: string;
  /** Настройки KYC проекта — см. mock_ss/docs/INTEGRATION_FRONTEND.md §«Per-project».
   *  kyc-svc будет читать (Phase 1, после расширения kyc.proto под
   *  level_name/project_id). Сейчас MVP — поля сохраняются в админке,
   *  backend не использует. */
  kyc?: {
    enabled?: boolean;
    levelName?: string;
    sumsubProjectId?: string;
    autoApproveDelay?: number;
    ttlInSecs?: number;
  };
  [key: string]: unknown;
}

/** Элемент role — сотрудник с доступом к проекту */
export interface ProjectRoleEntry {
  id?: string;
  profile_id?: string;
  user_id?: string;
  name?: string;
  [key: string]: unknown;
}

/** DTO проекта (ответ/тело API) */
export interface ProjectDTO {
  id: string;
  name: string;
  project_data?: ProjectData;
  role?: ProjectRoleEntry[];
  is_active?: boolean;
  create_date?: string;
  update_date?: string;
}

export const defaultProjectData: ProjectData = {
  icon: '',
  description: '',
  brand_book: '',
  api_access: {},
  chat_access: {},
  theme: '',
  enabled_menu: [],
  enabled_submenu: {},
  footer_link: '',
  services: '',
  from_email: '',
  assets_base_url: ''
};

/** DTO подключения сервисов (ServiceConnect): id, project_id, project_name, data, is_active, create_date, update_date */
export interface ServiceConnectDTO {
  id?: string;
  project_id?: string;
  project_name?: string;
  /** Данные подключения (JSON из БД) */
  data?: Record<string, unknown> | string;
  is_active?: boolean;
  create_date?: string;
  update_date?: string;
  [key: string]: unknown;
}
